var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "money-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('div', {
    staticClass: "uk-inline"
  }, [_c('input', {
    ref: "primaryInput",
    staticClass: "uk-input money-input__input",
    class: _vm.inputCss,
    attrs: {
      "type": "number",
      "step": "0.01",
      "min": "0",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "money-input__currency uk-form-icon uk-form-icon-flip"
  }, [_vm._v("\n      " + _vm._s(_vm.currency) + "\n    ")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b732525","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/MoneyInput.vue
// module id = 1845
// module chunks = 0